import homeImage from "@/assets/img/home2/image.png";
import "@/assets/sass/main.scss";
import videoFile from "@/assets/img/main_play.mp4";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Home2() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  let goFoundation = () => {
    navigate("/introduction-consortium");
  };

  return (<>
    {/*}
    <div className="home2">
      <img src={homeImage} alt="home" />
    </div>
    {*/}

   
    <div className="main">

         <video className="bg-video" autoPlay muted loop playsInline>
          <source src={videoFile} type="video/mp4" />
          브라우저가 video 태그를 지원하지 않습니다.
        </video>
        <div class="overlay"></div>

        <div className="main_content">
          <p class="desc">{t("components.maintitle1")}</p>
          <h1>{t("components.maintitle2")}</h1>
          <a href="/#/introduction-consortium" class="main-btn">{t("components.mainbtn")} <span>&#8594;</span></a>
        </div>
    </div>
  </>);
}